export default [
  {
    width: 17,
    header: {
      type: 'slot',
      name: 'currencyHeader',
    },
    cell: {
      type: 'slot',
      name: 'currency',
    },
  },
  {
    width: 17,
    header: {
      type: 'text',
      caption: 'Enabled',
    },
    cell: {
      type: 'slot',
      name: 'active',
    },
  },
  {
    width: 17,
    header: {
      type: 'text',
      caption: 'Deal amount (from-to)',
    },
    cell: {
      type: 'slot',
      name: 'merchantFees',
    },
  },
  {
    width: 17,
    header: {
      type: 'text',
      caption: 'Merchant fee',
    },
    cell: {
      type: 'slot',
      name: 'merchantProfit',
    },
  },
  {
    width: 17,
    header: {
      type: 'text',
      caption: '',
    },
    cell: {
      type: 'slot',
      name: 'actions',
    },
  },
];
